import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material'
import React from 'react';
import { SkeletonMeetPurpose } from '../Skeleton Loading/SkeletonMeetPurpose';
import { useState } from 'react';
import { SBSaveUpdateBtn } from '../SbButtons/SbAddBtn';
import { loadClientCategory, loadProductFilterData, loadProductsData, postProductFilterData } from '../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import * as HeaderAuthentication from "../HeaderAuthentication";
import moment from 'moment';
import { useEffect } from 'react';
import EditProductFilterModal from './EditProductFilterModal';
import { dateFormat } from 'highcharts';
import SbCancelBtn from '../SbButtons/SbCancelBtn';

function ProductFilterCategoryTable() {

    const { clientCategoryData } = useSelector((state) => state.data)
    const { productFilterData } = useSelector((state) => state.data)


    const [productDatas, setProductDatas] = useState([])
    useEffect(() => {
        if (productFilterData) {
            // let list = [...productFilterData]
            productFilterData.map((items) => {
                if (items.productPricing.length == 0) {
                    let pricingItem = []
                    clientCategoryData.map(catItem => {
                        if (catItem.status == 1) {
                            pricingItem.push({
                                subscriptionID: items.subscriptionID,
                                productID: items.productID,
                                productName: items.productName,
                                clientCategoryID: catItem.categoryID,
                                clientCategoryName: catItem.name,
                                clientPrice: 0,
                                type: "3Category",
                                // priceBy: "Category Client",
                                // priceBy: catItem.priceBy,
                                status: 1
                            })
                        }
                    })
                    items.productPricing = pricingItem

                }
            })
            setProductDatas(productFilterData)
        }
    }, [productFilterData])

    let dispatch = useDispatch();
    const resPassData = JSON.parse(sessionStorage.getItem("usrlgndtls"));
  console.log(resPassData,resPassData)
    //code for search bar

    const [filterArray, setFilterArray] = useState([])
    const [PageSize, setPageSize] = useState(20);
    const [pageCount, setPageCount] = useState(3);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);

    const [productId, setProductId] = useState('')
    const [editMode, setEditMode] = useState(false);
    const [show, setShow] = useState(false);

    useEffect(() => {
        dispatch(loadClientCategory());
        dispatch(loadProductFilterData())
    }, []);

    useEffect(() => {
        fetchProductData(filterArray, PageSize, currentPage)
    }, [filterArray, PageSize, currentPage])

    const fetchProductData = () => {
        if (filterArray.length === 0) {
            dispatch(loadProductsData(currentPage, PageSize, setIsLoading))
        }
    }



    let tableHeader = [
        { name: "PRODUCT CODE", align: "left", width: "150px" },
        { name: "PRODUCT NAME", align: "left", width: "150px" },
        { name: "PRODUCT CATEGORY", align: "left", width: "150px" },
        { name: "MRP", align: "left", width: "150px" },
        ...(clientCategoryData
            ? clientCategoryData
                .filter(data => data.status === 1)
                .map(data => ({ name: data.name, align: "center", width: "150px" }))
            : []),
        { name: "ACTION", align: "left", width: "150px" },

    ];


    const [methodType, setMethodType] = useState([])
    const handleInputChange = (e, categoryId, type, productId) => {
        let array = { categoryId: categoryId, type: type }
        if (methodType.length == 0) {
            const newData = [...methodType, array];
            setMethodType(newData)
        } else {
            methodType.filter(methodtype => {
                if (methodtype.categoryId != array.categoryId) {
                    const newData = [...methodType, array];
                    setMethodType(newData)
                }
            })
        }
        // console.log(array, "array")
        // if(Object.keys(array).length != 0){
        //     setMethodType([...methodType, array])
        // }

        let productList = [...productDatas]
        productList.map(item => {
            if (item.productID == productId) {
                item.productPricing.map(subitem => {
                    if (subitem.clientCategoryID == categoryId && subitem.type == type && subitem.productID == productId) {
                        subitem.clientPrice = parseFloat(e.target.value);
                    }
                })
            }
        })
        setProductDatas(productList)
    }



    const handleSave = (produId) => {
        if (methodType.length != 0) {
            let senddata = productDatas.filter(item => {
                return item.productID == produId;
            }
            )
            // let result = methodType.filter(method =>
            //     senddata[0].productPricing.every(data => {
            //         return (data.clientCategoryID == method.categoryId && data.type == method.type)
            //     }))
            const filteredArray = senddata[0].productPricing.filter(item1 =>
                methodType.some(item2 => item1.clientCategoryID == item2.categoryId && item1.type == item2.type)
            );

            let requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postTravelizeAuth,
                body: JSON.stringify(filteredArray),
            };
            dispatch(postProductFilterData(requestOption, setEditMode))
        }
    }

    const handleClose = () => {
        setShow(false);
        setEditMode(false)
    };

    // edit product button function

    const editProducts = (prodId) => {
        setEditMode(false)
        setProductId(prodId)
        setShow(true)
    }
    // edit product button function

    const enableInputFields = () => {
        setEditMode(true); // Enable input fields
        setShow(false); // Close the modal
    };



    return (
        <div className="sb-table-div sb-table-setion">
            <Paper sx={{ width: '100%', overflow: 'hidden' }} className='table-main-div'>
                <TableContainer sx={{ maxHeight: 440 }} >
                    <Table stickyHeader aria-label="sticky table table-responsive" className='product-pricing-table'>
                        <TableHead className='custom-table-header'>
                            <TableRow>
                                {tableHeader.map((name, i) => (
                                    < TableCell key={i} align={name.align} className={`thead-cell-products`}
                                        style={{ minWidth: name.width }}>
                                        {name.name}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        {isLoading ?
                            <>{tableHeader.map((name, i) => (
                                <SkeletonMeetPurpose key={i} />
                            ))}
                            </>
                            :
                            <>
                                {productDatas && productDatas.length === 0 ?
                                    <TableBody>
                                        <TableRow align="center" >
                                            <TableCell align="center" colSpan={tableHeader.length}>
                                                <div style={{ padding: "20px 20px" }}>
                                                    <img src="../../../../images/DefaultImages/NodataFound.jpg" alt="" style={{ width: "10%" }} /><br />
                                                    <span>No Data Found...!</span>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                    :
                                    <TableBody>
                                        {productDatas && productDatas.filter(data => data.productStatus === 1).map((data, i) => (
                                            <TableRow align="center" key={i} className='client-list-row-data'>

                                                <TableCell>
                                                    {data.productCode}
                                                </TableCell>
                                                <TableCell>
                                                    {data.productName}
                                                </TableCell>
                                                <TableCell>
                                                    {data.categoryName}
                                                </TableCell>
                                                <TableCell>
                                                    {data.productMRP}
                                                </TableCell>
                                                {/* Add input field for each item in clientCategoryData */}
                                                {/* {clientCategoryData && clientCategoryData.filter(category => category.status === 1).map((category, index) => ( */}
                                                {data.productPricing.map((item, i) => (
                                                    <>
                                                        {item.type == "3Category" &&
                                                            <TableCell key={i}>
                                                                <div className='table-input-div'>
                                                                    <input
                                                                        type="number"
                                                                        className={`${(editMode && productId == data.productID) ? "form-control table-input add-product-input" : "text-format-input"}`}
                                                                        value={item.clientPrice}
                                                                        style={{ width: "100%", textAlign: "center" }}
                                                                        // onChange={(event) => handleClientCategoryInputChange(event, data.productID)}
                                                                        onChange={(e) => handleInputChange(e, item.clientCategoryID, item.type, item.productID)}
                                                                        disabled={!editMode || productId !== data.productID}
                                                                    />
                                                                </div>

                                                            </TableCell>
                                                        }
                                                    </>
                                                ))}
                                                {/* ))} */}
                                                <TableCell>
                                                    <>
                                                        {(editMode && (productId == data.productID)) ?
                                                            <SBSaveUpdateBtn

                                                                onClickEffect={(e) =>
                                                                    handleSave(data.productID) // Call handleSave when Save button is clicked
                                                                }
                                                                btnName="Save" // Change button text based on the modal and product ID
                                                            />
                                                            :
                                                            <SbCancelBtn

                                                                onClickEffect={(e) =>
                                                                    editProducts(data.productID) // Show the modal when Edit button is clicked
                                                                }
                                                                btnName="Edit" // Change button text based on the modal and product ID
                                                            />
                                                        }
                                                    </>
                                                    {/* ))} */}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        {/* <TableCell>
                                            <SBSaveUpdateBtn/>
                                        </TableCell> */}
                                    </TableBody>
                                }
                            </>
                        }
                    </Table>
                </TableContainer>
            </Paper>
            {show && <EditProductFilterModal
                show={show}
                handleClose={handleClose}
                editProducts={editProducts}
                enableInputFields={enableInputFields}
            />}
        </div>
    )
}

export default ProductFilterCategoryTable;





